import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const communitiesTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/communities/$communityId/templates",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "CommunitiesOnboarding" */ "./CommunitiesTemplatesRoute"
      ),
    "CommunitiesTemplatesRoute",
  ),
});
